import { numberToUSD } from "../../../../utils"
import SectionCell from "../../cell"

interface Props {
  label: string
  value: number | string
}

const CurrencyValue = ({ label, value }: Props) => (
  <SectionCell label={label} value={value ? numberToUSD(value) : "-"} />
)

export default CurrencyValue
